export default __webpack_public_path__ + "static/media/notFound.b966f7d1.jpg";